import graphql__38d3d32c6080565c7818 from "./__generated__/SendContributorContactMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__38d3d32c6080565c7818;

function sendContributorContact(contributionId, onCompleted) {
  const variables = { contributionId };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { sendContributorContact };
